<template>
  <EditAdmin />
</template>

<script>
import EditAdmin from '@/components/editAdmin/EditAdmin'

export default {
  name: "EditAdminPage",
  components: {
    EditAdmin
  }
}
</script>

<style scoped lang="scss">

</style>